import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ServersPage } from "@/features/operator/ServersPage";

export const Route = createFileRoute("/app/operator/servers/")({
  validateSearch: z.object({ open: z.string().optional(), health: z.string().optional() }),
  component: ServersPage,
});
